(() => {
  function init(root) {
    if (root.dataset.prizeReady) return;
    root.dataset.prizeReady = 'true';
    const select = root.querySelector('[data-prize-select]');
    const links = root.querySelectorAll('[data-prize-model]');
    function sync() {
      links.forEach(link => {
        if (select && link.dataset.prizeModel === select.value) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    }
    links.forEach(link => link.addEventListener('click', event => {
      if (!select) return;
      event.preventDefault();
      select.value = link.dataset.prizeModel;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      root.querySelector('.og-prize__claim').scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
      select.focus({preventScroll: true});
    }));
    if (select) select.addEventListener('change', sync);
    sync();
    const status = root.querySelector('[data-prize-success], [data-prize-error]');
    if (status) { status.focus({preventScroll:true}); status.scrollIntoView({block:'center'}); }
  }
  document.querySelectorAll('[data-prize-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-prize-root]').forEach(init));
})();
